import { WorkerProfile } from './workforce.data';

export interface User {
  uid?: string; // must set to optional to conform with profile and wfworker
  email: string;
  emailVerified: boolean
  photoURL?: string;
  displayName?: string;
  firstName: string;
  lastName: string;
  country?: string;
  created?: Date
  // providerData?: string; <== was never used correctly, moving outside of user object anyway
  lastLogin?: Date;
  accounts?: string[];
  lastUsedAccountId?: string;
  currentAccount?: string;
  settings: UserSettings
  UTCOffset?: number
  viewedNotificationsAt?: any;
}

/* tslint:disable */
export interface JoiUser extends User {}
/* tslint:enable */

export interface UserWithProfile extends WorkerProfile, User {}

export type HomeType = 'EVENTS' | 'TASKS' | 'PUBLISH' | 'CLIPBOARD' | 'BUDGET'
export type DashboardPageType = 'card' | 'list' | 'table' | 'calendar'

export type EventOrderKey = 'first_date' | 'title'

export interface SortOption {
  event_order_key?: EventOrderKey;
  event_order_rev?: boolean;
}

export type TipType = 'revenue' | 'cost' | 'rick' | 'tax' | 'discount' | 'fees' | 'markup' | 'unitrate'

export interface UserSettings {
  event_order_key?: EventOrderKey
  event_order_rev?: boolean
  event_show_closed?: boolean
  show_quickguide_banner?: boolean
  email_monthly_receipts?: boolean
  email_postevent_reports?: boolean
  email_promo_joi?: boolean

  default_account?:string;
  last_visited_page?:string;
  currency?: string;
  budgetCurrency?: string
  country?: string;
  zoom?: number;
  homepage?: DashboardPageType
  notifs?: any;
  workforce_columns?: any;
  taskTable_columns?: any;
  calendarSubscriptionEvents?: string[]; // eventIds that the user wants a subscription to
  hiddenTips?: TipType[]
  showClosedBudgets?: boolean

}

export const getDefaultUserSettings = (): UserSettings => ({
  event_order_key:'first_date',
  event_order_rev:true,
  event_show_closed:true,
  show_quickguide_banner:true,
  currency: 'AUD',
  budgetCurrency: 'AUD',
  country: 'AU',
  zoom:null,
  homepage: 'card',
})

export interface PhotoData {
  photoURL?: string
  firstName?: string
  lastName?: string
  title?: string
}